<section class="container py-4 py-md-5">
  <div class="text-center mb-4 mb-md-5">
    <h1 class="text-white mb-2">Stream Argon everywhere</h1>
    <p class="text-white-50 mb-0">
      Choose your favorite platform and start listening.
    </p>
  </div>

  <div class="row row-cols-auto justify-content-center g-2 g-md-3">
    <div class="col">
      <a href="https://open.spotify.com/artist/34VHMZQmot7pmrFQwiv6BK" target="_blank" rel="noopener noreferrer"
        class="d-flex justify-content-center text-decoration-none">
        <div class="card shadow-sm border-0" style="width: 150px; aspect-ratio: 1 / 1;">
          <div class="card-body p-1 d-flex flex-column justify-content-center">
            <div class="d-flex flex-column align-items-center text-center gap-1">
              <img src="https://cdn.simpleicons.org/spotify/1DB954" alt="Spotify logo" width="24" height="24" />
              <h6 class="card-title mb-0">Spotify</h6>
            </div>
          </div>
        </div>
      </a>
    </div>

    <div class="col">
      <a href="https://music.apple.com/us/artist/argon/6792726634" target="_blank" rel="noopener noreferrer"
        class="d-flex justify-content-center text-decoration-none">
        <div class="card shadow-sm border-0" style="width: 150px; aspect-ratio: 1 / 1;">
          <div class="card-body p-1 d-flex flex-column justify-content-center">
            <div class="d-flex flex-column align-items-center text-center gap-1">
              <img src="https://cdn.simpleicons.org/applemusic/FA243C" alt="Apple Music logo" width="24" height="24" />
              <h6 class="card-title mb-0">Apple Music</h6>
            </div>
          </div>
        </div>
      </a>
    </div>

    <div class="col">
      <a href="https://music.youtube.com/channel/UC7eRU0q9jhL-HtlxQMptmFQ" target="_blank" rel="noopener noreferrer"
        class="d-flex justify-content-center text-decoration-none">
        <div class="card shadow-sm border-0" style="width: 150px; aspect-ratio: 1 / 1;">
          <div class="card-body p-1 d-flex flex-column justify-content-center">
            <div class="d-flex flex-column align-items-center text-center gap-1">
              <img src="https://cdn.simpleicons.org/youtubemusic/FF0000" alt="YouTube Music logo" width="24"
                height="24" />
              <h6 class="card-title mb-0">YouTube Music</h6>
            </div>
          </div>
        </div>
      </a>
    </div>

    <div class="col">
      <a href="https://vi.be/platform/argon" target="_blank" rel="noopener noreferrer"
        class="d-flex justify-content-center text-decoration-none">
        <div class="card shadow-sm border-0" style="width: 150px; aspect-ratio: 1 / 1;">
          <div class="card-body p-1 d-flex flex-column justify-content-center">
            <div class="d-flex flex-column align-items-center text-center gap-1">
              <img src="https://www.vi.be/favicon.ico" alt="VI.BE logo" width="24" height="24" />
              <h6 class="card-title mb-0">VI.BE</h6>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</section>